import { cx } from './cx.ts';
import s from './SegmentedToggle.module.css';
import t from './type.module.css';

/** Two or three ink-bordered capsules, the chosen one filled (S-07 Ours / Mine; approved 2026-10-20). */
export function SegmentedToggle({
  options,
  value,
  onChange,
  label,
  tone = 'standard',
}: {
  options: string[];
  value: number;
  onChange: (i: number) => void;
  label: string;
  /** `inverse` on an ink surface (the sidebar). */
  tone?: 'standard' | 'inverse';
}) {
  return (
    <fieldset className={cx(s.toggle, tone === 'inverse' && s.inverse)} aria-label={label}>
      {options.map((o, i) => (
        <button
          key={o}
          type="button"
          aria-pressed={i === value}
          className={cx(s.option, t.label, i === value && s.on)}
          onClick={() => onChange(i)}
        >
          {o}
        </button>
      ))}
    </fieldset>
  );
}
